import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { Area } from "../models/Area";
import { Pagination } from "../../../models/Pagination";
import { IPaginationQuery } from "../../../hooks/usePagination";

interface IUseAreas {
  params?: {
    search?: string;
    domain_id?: string;
  } & IPaginationQuery;
}

interface IUseAreasReturn {
  fetch: UseFetchResult<Area[]>;
  pagination: Pagination;
}

export const useAreas = ({ params }: IUseAreas = {}): IUseAreasReturn => {
  const { page = 1, search = "", per_page = 10, ...rest } = params || {};

  const fetch = useFetch<Area[]>("/api/areas", {
    initialData: [],
    params: {
      page,
      search,
      per_page,
      ...rest,
    },
  });

  const pagination = new Pagination(fetch.meta);

  return { fetch, pagination };
};
